<a href="home" class="sr-only focus:not-sr-only focus:absolute focus:top-0 focus:left-0 focus:z-50 focus:p-4 focus:bg-black focus:text-white" tabindex="0">
  Skip to main content
</a>
<div class="h-full !min-h-screen w-full flex flex-col">
  <app-header role="banner" aria-label="Site header"></app-header>
  <main id="main-content" class="flex-1" role="main" aria-label="Main content">
    <router-outlet class=""></router-outlet>

    @if(isAuthenticated()) {
      <div>
        <section
          class="border-dsr-border-small border-dsr-color-outline-variant rounded-dsr-radius-xlarge p-dsr-spacing-xlarge flex w-full flex-col items-center justify-center"
          role="complementary" aria-label="Chatbot assistance">
          <app-chatbot [(isCollapsibleChatbotOpen)]="isCollapsibleChatbotOpen" [displayFormat]="position()"
          role="application" aria-label="Interactive chatbot"></app-chatbot>
          @if(position() === "collapsible") {
            <app-chatbot-collapse-button
            [(isCollapsibleChatbotOpen)]="isCollapsibleChatbotOpen"></app-chatbot-collapse-button>
          }
        </section>
      </div>
    }
  </main>
  <app-footer role="contentinfo" aria-label="Site footer"></app-footer>
  @if(email && email != '') {
  <renault-ng-feedback #feedbackComponent [ipn]="email" irn="IRN-70121" triggerId="happi-feedback"
    base_url="https://re7.a5o.re7.asdh.aws.renault.com/sb/consumer/happi"
    (loaded)="onFeedbackLoaded($event)" (onHide)="onHideFeedback()"></renault-ng-feedback>
  }
</div>